export const getCurrentYearMonth = (): string => {
    const date = new Date()
    const year = date.getFullYear()
    const month = date.getMonth() + 1 // JavaScript months are 0-based
    const formattedMonth = month < 10 ? `0${month}` : month
    return `${year}-${formattedMonth}`
}
